import { OfficeServerDetails } from "../../../domain/repositories/ConfigRepository";

export const TRIGGER_GET_ALL_OFFICE_SERVERS = 'GET_ALL_OFFICE_SERVERS.TRIGGER';
export const GET_ALL_OFFICE_SERVERS_PENDING = 'GET_ALL_OFFICE_SERVERS.PENDING';
export const GET_ALL_OFFICE_SERVERS_SUCCESS = 'GET_ALL_OFFICE_SERVERS.SUCCESS';
export const GET_ALL_OFFICE_SERVERS_ERROR = 'GET_ALL_OFFICE_SERVERS.ERROR';

export const UPDATE_OFFICE_SERVERS = 'GET_ALL_OFFICE_SERVERS.UPDATE_OFFICE_SERVERS';

export const RESET_GET_ALL_OFFICE_SERVERS = 'GET_ALL_OFFICE_SERVERS.RESET';

export interface TriggerGetAllOfficeServers {
  type: typeof TRIGGER_GET_ALL_OFFICE_SERVERS;
}

export interface GetAllOfficeServersPending {
  type: typeof GET_ALL_OFFICE_SERVERS_PENDING;
}

export interface GetAllOfficeServersSuccess {
  type: typeof GET_ALL_OFFICE_SERVERS_SUCCESS;
  payload: {
    officeServers: OfficeServerDetails[];
  }
}

export interface GetAllOfficeServersError {
  type: typeof GET_ALL_OFFICE_SERVERS_ERROR;
}

export interface UpdateOfficeServers {
  type: typeof UPDATE_OFFICE_SERVERS;
  payload: {
    officeServers: OfficeServerDetails[];
  }
}

export interface ResetGetAllOfficeServers {
  type: typeof RESET_GET_ALL_OFFICE_SERVERS;
}


export type GetAllOfficeServersActionType =
  | TriggerGetAllOfficeServers
  | GetAllOfficeServersPending
  | GetAllOfficeServersSuccess
  | GetAllOfficeServersError
  | UpdateOfficeServers
  | ResetGetAllOfficeServers;


export interface GetAllOfficeServersState {
  getAllOfficeServersPending: boolean;
  getAllOfficeServersError: boolean;
  officeServers: OfficeServerDetails[] | null;
}